import * as yup from "yup";

export const questionTypeMap = {
  MCQ: "Multiple Choice Question",
  TF: "True/False",
  FIB: "Fill-In-The-Blank",
  CodingChallenges: "Coding",
  Descriptive: "Descriptive/Text",
};

export const questionTypePicMap = {
  MCQ: "mdi mdi-checkbox-marked-outline",
  "True/False": "mdi mdi-ab-testing",
  "Fill in Blanks": "mdi mdi-border-color",
  "Coding Challenge": "mdi mdi-code-tags",
  Descriptive: "mdi mdi-text",
};

export const QuestionLevel = {
  Entry: "info",
  Beginner: "info",
  Intermediate: "warning",
  Advanced: "danger",
};

export const QuestionDifficulty = {
  Easy: "success",
  Medium: "warning",
  Hard: "danger",
};

export const QuestionTopic = {
  Java: "warning",
  Python: "primary",
  "Cloud Computing": "info",
};

export const initialValues = {
  questionTitle: "",
  topic: "",
  questiontype: "",
  difficulty: "",
  level: "",
  answers: [
    {
      Options: [""],
      Answers: [""],
    },
  ],
};

export const populateForm = (value) => {
  return {
    questionTitle: value.questionTitle,
    topic: value.topic,
    questiontype: value.questiontype,
    difficulty: value.difficulty,
    level: value.level,
    answers: value.answers?.map((answer) => ({
      Options: answer.Options,
      Answers: answer.Answers,
    })),
  };
};

export const validationSchema = yup.object().shape({
  questionTitle: yup.string().required("Question is required."),
  topic: yup
    .string()
    .test("not-select", "Please select a topic.", (value) => value !== "Select")
    .required("Topic is required."),
  questiontype: yup
    .string()
    .test("not-select", "Please select a type.", (value) => value !== "Select")
    .required("Type is required."),
  difficulty: yup
    .string()
    .test(
      "not-select",
      "Please select a difficulty.",
      (value) => value !== "Select"
    )
    .required("Difficulty is required."),
  level: yup
    .string()
    .test("not-select", "Please select a level.", (value) => value !== "Select")
    .required("Level is required."),
  answers: yup
    .array()
    .of(
      yup.object().shape({
        Options: yup
          .array()
          .of(yup.string().required("Option is required."))
          .min(1, "At least one option is required."),
        Answers: yup
          .array()
          .of(yup.string().required("Answer is required."))
          .min(1, "At least one answer is required."),
      })
    )
    .min(1, "At least one set of answers is required."),
});
